import React, { useEffect } from 'react';

import { useApp } from '../../store/AppContext';

// Une erreur ou une information (récapitulatif à lire) reste affichée jusqu'à ce qu'on la ferme ;
// un succès disparaît seul.
const AUTO_HIDE_MS = 5000;

const KIND_CLASSES = {
  error: 'bg-[#FDECEC] border-[#F5B5B4] text-[#8A1F1E]',
  success: 'bg-[#E6F6EE] border-[#A8DCC0] text-[#14532D]',
  info: 'bg-white border-[#DCE5E7] text-navy',
};

export default function Toast({ toast }) {
  const { removeToast } = useApp();
  const { id, kind, message } = toast;
  useEffect(() => {
    if (kind !== 'success') return undefined;
    const timer = setTimeout(() => removeToast(id), AUTO_HIDE_MS);
    return () => clearTimeout(timer);
  }, [id, kind, removeToast]);
  return (
    <div
      role={kind === 'error' ? 'alert' : 'status'}
      className={`flex items-start gap-[10px] border rounded-[12px] px-[14px] py-[10px] text-[13px] leading-[1.5] shadow-[0_8px_24px_rgba(2,56,72,0.12)] ${KIND_CLASSES[kind] || KIND_CLASSES.info}`}
    >
      <p className="flex-1 m-0 whitespace-pre-line">{message}</p>
      <button
        type="button"
        className="bg-transparent border-0 cursor-pointer text-[16px] leading-none text-inherit p-0"
        aria-label="Fermer le message"
        onClick={() => removeToast(id)}
      >
        ×
      </button>
    </div>
  );
}
